module.exports = __webpack_public_path__ + "img/vote_bg.a9a9d3d7.png";